import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  item: {
    display: 'table-cell',
    maxWidth: 350,
    margin: 'auto',
    marginTop: '16px',
    [theme.breakpoints.only('lg')]: {
      display: 'table-cell',
      maxWidth: 350,
      margin: '5% 5% 5% 10%',
      marginTop: '16px',
    },
  },
});

function VerticalSlider(props) {
  const { children, classes } = props;
  return (
    <div>
      <Grid className={classes.root} container>
        {React.Children.map(children, (child, i) => (
          <Grid xs={12} sm={6} md={4} className={classes.item} key={i} item>
            {child}
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

VerticalSlider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VerticalSlider);
